import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function RoleValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    name: Yup.string()
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
  });

  return validation;
}
